/* Desplazamiento suave a una sección de la portada (respeta "reducir movimiento"). */
export function irA(id) {
  const el = typeof document !== 'undefined' ? document.getElementById(id) : null;
  if (!el) return false;
  const reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const y = el.getBoundingClientRect().top + window.scrollY - 76;      // compensa la barra fija
  window.scrollTo({ top: y, behavior: reducir ? 'auto' : 'smooth' });
  return true;
}
